/** Shared smooth-scroll behavior for in-page anchor navigation. */

export function prefersReducedMotion() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Scrolls an anchor target into view, respecting the fixed header offset
 *  (via CSS scroll-margin-top) and the user's motion preference. */
export function scrollToHash(hash: string, opts?: { instant?: boolean }) {
  if (typeof document === "undefined") return false;
  const id = hash.replace(/^#/, "");
  if (!id) {
    window.scrollTo({
      top: 0,
      behavior: opts?.instant || prefersReducedMotion() ? "auto" : "smooth",
    });
    return true;
  }

  const el = document.getElementById(id);
  if (!el) return false;

  el.scrollIntoView({
    behavior: opts?.instant || prefersReducedMotion() ? "auto" : "smooth",
    block: "start",
  });

  // Keep keyboard focus in sync with the visual jump without a second scroll.
  const focusable = el as HTMLElement;
  if (!focusable.hasAttribute("tabindex")) focusable.setAttribute("tabindex", "-1");
  focusable.focus({ preventScroll: true });

  return true;
}

/** Retries briefly so targets that mount after a route change still land. */
export function scrollToHashWhenReady(hash: string, tries = 20) {
  if (typeof window === "undefined") return;
  let attempts = 0;
  const tick = () => {
    if (scrollToHash(hash) || attempts >= tries) return;
    attempts += 1;
    window.requestAnimationFrame(tick);
  };
  window.requestAnimationFrame(tick);
}
